import exponent from "./exponent";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-format/src/precisionFixed.js
// module id = ETvy
// module chunks = 0